import { v4 as uuidv4 } from 'uuid'

const { localStorage } = window

enum Storage {
  basePrefix = 'EMBRACE_PWA',
  language = 'LANGUAGE',
  onboardedSuffix = 'ONBOARDED',
  versionSuffix = 'BUNDLE_VERSION',
  deviceID = 'DEVICE_ID',
}

export const storageDefaults = {
  language: 'en',
}

export const LanguageChange = new Event('language-change')
export const SoundsChange = new Event('sounds-change')

export const setBundleVersion = (version: string): void =>
  localStorage.setItem(
    `${Storage.basePrefix}_${Storage.versionSuffix}`,
    version
  )

export const getBundleVersion = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.versionSuffix}`)

export const setLanguage = (language: string): void => {
  localStorage.setItem(`${Storage.basePrefix}_${Storage.language}`, language)
  // see src/components/Player/index.tsx
  document.dispatchEvent(LanguageChange)
}

export const getLanguage = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.language}`)

export const setDeviceID = (): void => {
  if (!localStorage.getItem(`${Storage.basePrefix}_${Storage.deviceID}`)) {
    const uuid = uuidv4()
    localStorage.setItem(`${Storage.basePrefix}_${Storage.deviceID}`, uuid)
  }
}
export const getDeviceID = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.deviceID}`)

export const setOnboarded = (): void =>
  localStorage.setItem(
    `${Storage.basePrefix}_${Storage.onboardedSuffix}`,
    'true'
  )

export const getOnboarded = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.onboardedSuffix}`)
